import * as angular from 'angular';
import { ManageUsersHeaderComponent } from './manage-users-header.component';

export const ManageUsersHeaderModule = angular
  .module('manageUsersHeader', [])
  .component('manageUsersHeader', ManageUsersHeaderComponent).name;
